import React from "react";
import LeftIndent from "utils/LeftIndent";
import AlertList from "alerts/alert_summary/AlertList";
import RandomQuoteGenerator from "utils/RandomQuoteGenerator";
import { Button } from "react-bootstrap";
class AlertSummary extends React.Component {
  constructor(props) {
    super(props);
  }

  refreshPage = () => {
    location.reload();
  };

  render() {
    const today = new Date();
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    const twoDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 2);
    let quote = RandomQuoteGenerator(this.props);
    let allResolved =
      Object.keys(this.props.alerts.todaysAlerts).length == 0 &&
      Object.keys(this.props.alerts.yesterdaysAlerts).length == 0 &&
      Object.keys(this.props.alerts.otherAlerts).length == 0;
    return (
      <>
        <div className="d-flex account-alerts-header">
          <h1>Alert Summary</h1>
          {!allResolved && (
            <Button variant="success" className="ml-auto mb-5 height-min-content" onClick={this.refreshPage}>
              Refresh to see only active alerts
            </Button>
          )}
        </div>

        {allResolved ? (
          <>
            <div className="all-resolved">
              <p>All set for now!</p>
              <div className="success-quote d-flex flex-column">
                <h4 className={quote.className ? quote.className : undefined}>"{quote.text}"</h4>
                <h5 className="ml-auto">- {quote.author}</h5>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="mb-5">
              <LeftIndent>
                <div className="alert-group">
                  <h3>Today's Alerts ({today.toLocaleDateString()})</h3>
                  <AlertList {...this.props} alerts={this.props.alerts.todaysAlerts} />
                </div>
              </LeftIndent>
            </div>
            <div className="mb-5">
              <LeftIndent>
                <div className="alert-group">
                  <h3>Yesterday's Alerts ({yesterday.toLocaleDateString()})</h3>
                  <AlertList {...this.props} alerts={this.props.alerts.yesterdaysAlerts} />
                </div>
              </LeftIndent>
            </div>
            <div className="mb-5">
              <LeftIndent>
                <div className="alert-group">
                  <h3>All Other Alerts (including and prior to {twoDaysAgo.toLocaleDateString()})</h3>
                  <AlertList {...this.props} alerts={this.props.alerts.otherAlerts} />
                </div>
              </LeftIndent>
            </div>
          </>
        )}
      </>
    );
  }
}

export default AlertSummary;
